import { apiClient } from '@/lib/api/client';
export const itinerariesApi = {
    async list(groupId) {
        const { data } = await apiClient.get(`/api/v1/groups/${groupId}/itineraries`);
        return data;
    },
    async create(groupId, dto) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/itineraries`, dto);
        return data;
    },
    async update(groupId, id, dto) {
        const { data } = await apiClient.patch(`/api/v1/groups/${groupId}/itineraries/${id}`, dto);
        return data;
    },
    async delete(groupId, id) {
        await apiClient.delete(`/api/v1/groups/${groupId}/itineraries/${id}`);
    },
    async addActivity(groupId, itineraryId, activityId) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/itineraries/${itineraryId}/activities/${activityId}`);
        return data;
    },
    async removeActivity(groupId, itineraryId, activityId) {
        await apiClient.delete(`/api/v1/groups/${groupId}/itineraries/${itineraryId}/activities/${activityId}`);
    },
    async clone(groupId, itineraryId, targetGroupId) {
        const { data } = await apiClient.post(`/api/v1/groups/${groupId}/itineraries/${itineraryId}/clone?targetGroupId=${targetGroupId}`);
        return data;
    },
};
//# sourceMappingURL=itineraries.js.map